/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EmployeeFileScopeFilter } from './employeeFileScopeFilter';


export interface EmployeeFileIncludeFilterItems { 
    relation?: EmployeeFileIncludeFilterItems.RelationEnum;
    scope?: EmployeeFileScopeFilter;
}
export namespace EmployeeFileIncludeFilterItems {
    export type RelationEnum = 'user' | 'company' | 'catalog';
    export const RelationEnum = {
        User: 'user' as RelationEnum,
        Company: 'company' as RelationEnum,
        Catalog: 'catalog' as RelationEnum
    };
}


